export * from './registered-trademark.pipe';
